import { CircularProgress } from '@mui/material';
import { FlexDiv } from 'crono-fe-common/components/Layout/FlexDiv';
import { useAccountDrawer } from 'context/accountDrawer';
import useGetAccount from 'hooks/services/account/useGetAccount';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PATH from 'crono-fe-common/constants/path';

const TaskInterceptor = () => {
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get('accountId') ?? undefined;
  const { openAccountDrawer } = useAccountDrawer();

  const { isSuccess, error } = useGetAccount(accountId);

  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess && accountId) {
      openAccountDrawer({ accountId, initialTab: 'timeline' });
    }
  }, [isSuccess, accountId]);

  useEffect(() => {
    if (error || isSuccess) {
      navigate(PATH.HOME);
    }
  }, [error, isSuccess]);

  useEffect(() => {
    if (!accountId) {
      navigate(PATH.HOME);
    }
  }, [accountId]);

  return (
    <>
      <FlexDiv>
        <CircularProgress />
      </FlexDiv>
    </>
  );
};

export default TaskInterceptor;
